import { EOtherIncomeType } from '@if/core/types'
import { formatCurrencyNoDecimals } from '@if/core/utils'
import { useAppSelector } from '../../../data/store'
import { appSelectors } from '../../../data/store/AppStore'
import { CreditApplication } from '../../../data/types'
import { TranslatedEnum } from '../../../data/types/TranslatedEnum'

interface Props {
  otherIncomeId: string | undefined
  isForApplicant: boolean
  creditApplication: CreditApplication
}

const OtherIncomeTaskDescription = ({ otherIncomeId, isForApplicant, creditApplication }: Props) => {
  const otherIncomeTypeEnum = useAppSelector(appSelectors.getOtherIncomeTypesEnum)
  const lang = useAppSelector(appSelectors.getCurrentLang) as keyof TranslatedEnum

  const getOtherIncomeFromId = () => {
    if (otherIncomeId) {
      const otherIncomes = isForApplicant
        ? creditApplication.applicant.otherIncomes
        : creditApplication.coApplicant?.otherIncomes
      return otherIncomes?.find((x) => x.id === otherIncomeId)
    }
    return undefined
  }

  const otherIncomeJob = getOtherIncomeFromId()
  return (
    <div>
      {otherIncomeJob?.typeId &&
        otherIncomeTypeEnum[otherIncomeJob?.typeId][lang].concat(
          `${
            otherIncomeJob?.typeId === EOtherIncomeType.Other ? ` : ${otherIncomeJob.description}` : ''
          } (${formatCurrencyNoDecimals(otherIncomeJob?.annualAmount)})`,
        )}
    </div>
  )
}

export default OtherIncomeTaskDescription
